import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  returnedProducts: [],
  refundJSON: {},
  refundSource: null,
  paymentDetails: {},
  paymentStatus: {},
};

const returnedProductsSlice = createSlice({
  name: "Returned products",
  initialState,
  reducers: {
    addReturnedProducts: (state, { payload }) => {
      state.returnedProducts = payload;
    },
    addRefundJSON: (state, { payload }) => {
      state.refundJSON = payload;
    },
    addRefundSource: (state, { payload }) => {
      state.refundSource = payload;
    },
    addPaymentDetails: (state, { payload }) => {
      state.paymentDetails = payload;
    },
    addPaymentStatus: (state, { payload }) => {
      state.paymentStatus = payload;
    }
  },
});

export const { addReturnedProducts, addRefundJSON, addRefundSource, addPaymentDetails, addPaymentStatus } =
  returnedProductsSlice.actions;

export const getReturnedProducts = (state) =>
  state.returnedReducer.returnedProducts;

export const getRefundJSON = (state) => state.returnedReducer.refundJSON;

export const getRefundSource = (state) => state.returnedReducer.refundSource;

export const getPaymentDetails = (state) => state.returnedReducer.paymentDetails;

export const getPaymentStatus = (state) => state.returnedReducer.paymentStatus;

export default returnedProductsSlice.reducer;
